function d(a, f, i) {
  return a === a && (i !== void 0 && (a = a <= i ? a : i), f !== void 0 && (a = a >= f ? a : f)), a;
}
var t = d;
export {
  t as default
};
//# sourceMappingURL=_baseClamp.js.map
